import Layout from '@/layout'
const reportRouter = {
  path: '/Report',
  component: Layout,
  redirect: '/Report/reportList',
  name: 'Report',
  alwaysShow: true,
  meta: {
    title: '报表',
    icon: 'Selection'
    // icon: 'AutomaticShelving'
  },
  children: [
    {
      path: '/Report/reportList',
      name: "reportList",
      component: () => import("@/views/report/reportList/index.vue"),
      meta: {
        title: "仪表盘",
      }
    },
    {
      path: '/Report/shopReportList',
      name: "shopReportList",
      component: () => import("@/views/report/shopReportList/index.vue"),
      meta: {
        title: "店铺报表",
      }
    }
  ]
}

export default reportRouter;